import { makeStyles } from "@mui/styles";

const navBarStyle=makeStyles((theme)=>({
    mainContainer: {
        backgroundColor: "#008374 !important",
        lineHeight: "0 !important",
        padding: "8px 108px !important",
        position: "sticky",
        top: "0",
        zIndex: "999",
        [theme.breakpoints.down(1200)]: {
          padding: "15px 1px !important",
        },
      },
    
      header: {
        backgroundColor: "transparent !important",
        boxShadow: "none !important",
      },
    
      toolbar: {
        padding: "0px 0px !important",
      },
      navlinks: {
        marginLeft: theme.spacing(10),
        display: "flex !important",
        [theme.breakpoints.down(1260)]: {
          display: "none !important",
        },
      },
      logo: {
        "&.MuiTypography-root": {},
        fontSize: "30px !important",
        flexGrow: "1",
        cursor: "pointer",
        fontWeight: "600 !important",
      },
      link: {
        color: "rgba(255, 255, 255, 0.6) !important",
        textDecoration: "none !important",
        marginRight: "40px !important",
        position: "relative !important",
        cursor: "pointer !important",
        fontSize: "16px !important",
        fontWeight: "600 !important",
        transition: "0.3s",
        "&:hover": {
          color: "#fff !important",
        },
        // "&:after": {
        //   content: " ",
        //   position: "absolute !important",
        //   backgroundColor: "orange !important",
        //   height: "3px important",
        //   width: "100% !important",
        //   left: "0 !important",
        //   bottom: "-10px !important",
        // },
        // "&:hover:after": {
        //   width: "100% !important",
        // },
      },
    
      menuIcon: {
        fontSize: "28px !important",
        color: "rgba(255, 255, 255, 0.6) !important",
        marginRight: "30px !important",
        display: "none !important",
        [theme.breakpoints.down(1265)]: {
          display: "block !important",
          marginRight: "0px !important",
        },
      },
}))

export default navBarStyle;